import {Component, input} from '@angular/core';
import {ProgressSpinner} from 'primeng/progressspinner';
import {LoadingSize} from './loading.types';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  imports: [ProgressSpinner],
})
export class LoadingComponent {
  readonly size = input<LoadingSize>(LoadingSize.LARGE);

  protected readonly LoadingSize = LoadingSize;
}
